var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17265",
    "data-name": "Group 17265",
    transform: "translate(18989 16116)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1999",
    "data-name": "Rectangle 1999",
    width: 20,
    height: 20,
    transform: "translate(-18989 -16116)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "book",
    transform: "translate(-19102.352 -16112.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8358",
    "data-name": "Path 8358",
    d: "M118.352,11.337c.016-.012.035-.021.051-.033.033-.023.068-.044.1-.065a2.079,2.079,0,0,1,.218-.119c.041-.018.079-.036.119-.052a2.126,2.126,0,0,1,.247-.077c.029-.007.056-.02.085-.026V1.946a1.235,1.235,0,0,0-.823,1.159Zm0,0",
    transform: "translate(0 -1.398)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8359",
    "data-name": "Path 8359",
    d: "M190.352,48.473h4.116v1.646h-4.116Zm0,0",
    transform: "translate(-68.296 -45.53)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8360",
    "data-name": "Path 8360",
    d: "M128.23,193.3v-.823h-8.644a1.235,1.235,0,1,0,0,2.47h8.644v-.823h-8.644V193.3Zm0,0",
    transform: "translate(0 -182.122)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8361",
    "data-name": "Path 8361",
    d: "M158.584.473h-8.232V9.528h8.232ZM157.349,5a.412.412,0,0,1-.412.412H152A.412.412,0,0,1,151.587,5V2.531A.412.412,0,0,1,152,2.119h4.939a.412.412,0,0,1,.412.412Zm0,0",
    transform: "translate(-30.354 0)",
    fill: "#3f2566"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.47e6c9e5066eacae0d6afda43933e2be.svg";
export { ForwardRef as ReactComponent };